import React from 'react'
import styles from '../styles/swiperUI.module.scss'
import { Swiper, SwiperSlide } from 'swiper/react'

const SwiperUI = (props) => {
  const {data, handleSlideChangeRetry, renderChildren, loop=false, slidesPerView='auto', spaceBetween=0, children }=props
  return <div>
    <Swiper
      spaceBetween={spaceBetween}
      slidesPerView={slidesPerView}
      onSlideChange={(swiper)=>{
        handleSlideChangeRetry?.(swiper.realIndex)
      }}
      loop={loop}
    >
      {data?.map((v,index)=>{
        return(
          <SwiperSlide key={index}>
            {renderChildren && renderChildren(v, index)}
          </SwiperSlide>
        )
      })}
    </Swiper>
  </div>
}

export default SwiperUI